import { IMicrofrontendsAPI } from 'shared/types/microfrontends/types';

import { getDesktopFiltersMicrofrontendApi } from './getDesktopFiltersMicrofrontendApi';
import { getSearchStringMicrofrontendAPI } from './getSearchStringMicrofrontendApi';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    getSearchStringMicrofrontendAPI,
    getDesktopFiltersMicrofrontendApi,
  };
}
